// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__P4glC","default":"Checkbox_default__UfBkH","small":"Checkbox_small__L4NeO","input":"Checkbox_input__DNVtY"};